import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
/**
 * For insert menu in right rail experiment
 * - Clean up ticket ED-24801
 */
export var elementBrowserPmKey = new PluginKey('elementBrowserPmPlugin');

/**
 * For insert menu in right rail experiment
 * - Clean up ticket ED-24801
 */
export var elementBrowserPmPlugin = function elementBrowserPmPlugin() {
  return new SafePlugin({
    key: elementBrowserPmKey,
    state: {
      init: function init() {
        return {
          menuBrowserOpen: false
        };
      },
      apply: function apply(tr, pluginState) {
        var meta = tr.getMeta(elementBrowserPmKey);
        if (!meta) {
          return pluginState;
        }
        return {
          menuBrowserOpen: !pluginState.menuBrowserOpen
        };
      }
    }
  });
};